import type { IpAssets, SiteTheme } from "~/theme/types";

const IMG = "/images/ip/seeing-double";

export const seeingdoubleTheme: SiteTheme = {
  slug: "seeingdouble",
  tokens: {
    primary: "#5bb8d4",
    primarySoft: "rgba(91,184,212,0.15)",
    primaryHover: "#3a9bbf",
    primaryGlow: "91,184,212",
    bg: "#f7fbfd",
    surface: "#e8f4f8",
    text: "#1a2a3a",
    textBody: "#6a8a9a",
    textMuted: "#6a8a9a",
  },
};

export const seeingdoubleAssets: IpAssets = {
  imagesBase: IMG,
  logos: {
    ko: `${IMG}/logo_kr.webp`,
    en: `${IMG}/logo_en.webp`,
    ja: `${IMG}/logo_ja.webp`,
  },
  logoAlt: {
    ko: "라온의 남자",
    en: "Seeing Double",
    ja: "ラオンの彼",
  },
  sectionTitles: {
    characters: `${IMG}/title_Characters.webp`,
    news: `${IMG}/title_news.webp`,
    goods: `${IMG}/title_goods.webp`,
  },
  heroVisuals: [
    {
      id: 1,
      bg: `${IMG}/hero_bg.webp`,
      char: `${IMG}/hero_character.webp`,
      thumb: `${IMG}/kv_a_clean.webp`,
      label: "KEY VISUAL 01",
    },
    {
      id: 2,
      bg: `${IMG}/kv_02_bg.webp`,
      char: `${IMG}/kv_02_char.webp`,
      thumb: `${IMG}/kv_02_thumb.webp`,
      label: "KEY VISUAL 02",
    },
  ],
  pvVideoIds: {
    ko: "9bjOxKG18ZE",
    en: "px960Vb1y-E",
    ja: "Pjq67eVPJ1U",
  },
  pvPreview: `${IMG}/pv_preview.mp4`,
  pvPreviewByLocale: {
    ko: `${IMG}/pv_preview.mp4`,
    en: `${IMG}/pv_preview_en.mp4`,
    ja: `${IMG}/pv_preview_ja.mp4`,
  },
  laftelOnly: `${IMG}/laftel_only.webp`,
  loading: {
    assets: [
      `${IMG}/hero_bg.webp`,
      `${IMG}/hero_character.webp`,
      `${IMG}/logo_kr.webp`,
      `${IMG}/logo_ja.webp`,
      `${IMG}/logo_en.webp`,
      `${IMG}/kv_kr.webp`,
      `${IMG}/kv_ja.webp`,
      `${IMG}/kv_en.webp`,
    ],
    logoSrc: `${IMG}/logo_kr.webp`,
    logoAlt: "라온의 남자",
  },
};
